export const TbankIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
			<rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" />
			<rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#F0F0F0" />
			<path
				d="M10 11H30.087V21.5636C30.087 24.2701 28.7049 26.7743 26.4634 28.1257L20.0435 32L13.6235 28.1257C11.3821 26.7706 10 24.2701 10 21.5636V11Z"
				fill="#FFDD2D"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.4774 17.391V20.1661C15.9103 19.7362 16.6967 19.4486 17.5986 19.4486H18.5762V22.6725C18.5762 23.5291 18.3092 24.2813 17.916 24.6953H22.1692C21.776 24.2813 21.5091 23.5322 21.5091 22.6757V19.4486H22.4866C23.3849 19.4486 24.175 19.7394 24.6079 20.1661V17.391H15.4774Z"
				fill="#333333"
			/>
		</svg>
	)
}
